module.exports = __webpack_public_path__ + "static/media/catalouge-38.4cde8a8f.jpg";